// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductCompareCarouselStyles } from "@guestsupply/Overrides/Widgets/ProductCompare/ProductCompareCarousel";
import { color, ellipsis } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import X from "@insite/mobius/Icons/X";
import { css } from "styled-components";

ProductCompareCarouselStyles.navigationLinkGridItem = {
    width: 12,
};

ProductCompareCarouselStyles.navigationLink = {
    icon: { iconProps: { src: ChevronLeft } },
    typographyProps: { size: 15 },
};

ProductCompareCarouselStyles.headerGridItem = {
    width: 12,
};

ProductCompareCarouselStyles.headerTextGridItem = {
    width: [12, 6, 6, 6, 6],
};

ProductCompareCarouselStyles.headerText = {
    variant: "h2",
    forwardAs: "h1",
};

ProductCompareCarouselStyles.headerButtonsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        justify-content: flex-end;
    `,
};

ProductCompareCarouselStyles.headerRemoveAllButton = {
    variant: "tertiary",
};

ProductCompareCarouselStyles.carouselGridItem = {
    width: 12,
};

ProductCompareCarouselStyles.removeProductFromCompareClickable = {
    css: css`
        position: absolute;
        right: 0;
        &:hover {
            background: none;
            border-color: transparent;
            & > ${IconWrapper} {
                color: ${color("common.ui6", 0.33)};
            }
        }
        &:focus {
            background: none;
            border-color: transparent;
        }
    `,
};

ProductCompareCarouselStyles.removeProductFromCompareButtonIcon = {
    src: X,
};

ProductCompareCarouselStyles.productCarouselProduct = {
    productAddToListWrapper: {
        css: css`
            width: 100%;
            display: flex;
            justify-content: space-between;
        `,
    },
    productDescriptionStyles: {
        productDetailLink: {
            css: css`
                margin-bottom: 8px;
                height: 32px;
                ${ellipsis(2)}
            `,
            typographyProps: {
                size: 12,
                weight: 700,
                lineHeight: "16px",
                css: css`
                    &&& {
                        color: ${color("text.main")};
                    }
                `,
            },
        },
    },
    productGridContainerStyles: {
        container: {
            css: css`
                .middle-section {
                    flex: 1;
                }
                .bottom-section {
                    height: 62px;
                }
            `,
        },
        info: {
            css: css`
                height: 100%;
            `,
        },
    },
    imageAndDescriptionSection: {
        css: css`
            height: 100%;
            display: flex;
            flex-direction: column;
            .product-description {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
            }
        `,
    },
    productPriceWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
        `,
    },
};

ProductCompareCarouselStyles.removeIcon = {
    css: css`
        height: 30px;
        position: absolute;
        right: 12px;
        top: 5px;
        z-index: 10;
        ${IconWrapper}, svg {
            opacity: 0.7;
            color: ${color("secondry")};
            width: 13px;
            height: 18px;
            line-height: 22px;
            text-align: center;
            font-weight: 400;
            &:hover {
                opacity: 1;
                color: ${color("primary")};
            }
        }
    `,
};
